var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notification-container"},_vm._l((_vm.notification.notifications),function(notification){return _c('NotificationBar',{key:notification.id,attrs:{"notification":notification}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }